// @flow
import React from 'react';
import ReactDOM from 'react-dom';
import {Button} from 'reactstrap'
import Autosuggest from 'react-autosuggest';
import IsolatedScroll from 'react-isolated-scroll';
import AbstractField from "./AbstractField";
import {COMPONENT_CHILDREN} from './../Utils2';
import Icon from "./../icon/FAIcon"
import "./SuggestField.less"
import {mergeAddons} from "./../utils"
import highlightText from "../utils/highlightText";

const SUGGEST_THEME = {
    container: 'react-autosuggest__container',
    containerOpen: 'react-autosuggest__container--open',
    input: 'form-control react-autosuggest__input',
    suggestionsContainer: 'react-autosuggest__suggestions-container',
    suggestion: 'react-autosuggest__suggestion',
    suggestionFocused: 'react-autosuggest__suggestion--focused',
    sectionContainer: 'react-autosuggest__section-container',
    sectionTitle: 'react-autosuggest__section-title',
    sectionSuggestionsContainer: 'react-autosuggest__section-suggestions-container'
};

/**
 * Object Suggest field
 *
 * Alias autocomplete
 * Vrací objekty jako hodnoty hodnoty
 */
class ObjectSuggestField extends AbstractField {

    static PropTypes = {
        dropdown: React.PropTypes.bool,
        removable: React.PropTypes.bool,
        renderSuggestion: React.PropTypes.func, // render funkce jedné položky, předpis: (i, active, getItemValue, itemValueAttrName) => {}
        filterSuggestions: React.PropTypes.func,
        itemValueAttrName: React.PropTypes.string,  // název atributu v objekt, který je možné použít jako název pro zobrazení uživateli - je možné definovat jen atribut místo celé metody getItemValue, implicitně má hodnotu name
        getItemValue: React.PropTypes.func, // funkce pro načtení hodnoty pro zobrazení uživateli - název položky, předpis: (i, itemValueAttrName) => {}
        shouldRenderSuggestions: React.PropTypes.func,
        items: React.PropTypes.array.isRequired,
        tags: React.PropTypes.bool, // po zadani hodnoty se vymaže
        addonsBefore: COMPONENT_CHILDREN,
        addonsAfter: COMPONENT_CHILDREN,
        minCharsForFilter: React.PropTypes.number,  // minimální počet znaků, od kterých se bude filtrovat, standardně 0
    };

    static defaultProps = {
        tags: false,
        itemValueAttrName: "name",
        dropdown: false,
        removable: false,
        minCharsForFilter: 0,
        renderSuggestion: (i, active, getItemValue, itemValueAttrName, inputValue) => {
            const text = getItemValue(i, itemValueAttrName || "name");
            return (
                <div className={active ? "active" : ""}>{highlightText(inputValue, text)}</div>
            )
        },
        filterSuggestions: (value, list, getItemValue, itemValueAttrName) => {
            return new Promise((resolve, reject) => {
                if (value === null || value.length === 0) {
                    resolve(list);
                    return list;
                }
                const inputValue = value.trim().toLowerCase();
                const inputLength = inputValue.length;

                const result = inputLength === 0 ? [] : list.filter(item =>
                        // getItemValue(item, itemValueAttrName || "name").toLowerCase().slice(0, inputLength) === inputValue
                        getItemValue(item, itemValueAttrName || "name").toLowerCase().indexOf(inputValue) !== -1
                    );
                resolve(result);
            });
        },
        getItemValue: (i, itemValueAttrName = "name") => i ? i[itemValueAttrName] : "",
        shouldRenderSuggestions: (value) => true,
    };

    constructor(props) {
        super(props);

        const inputValue = props.value ? props.getItemValue(props.value, props.itemValueAttrName || "name") : "";

        this.hasFocus = false;
        this.alwaysRenderSuggestions = false;
        this.ignoreBlur = false;
        this.componentIsUnmounting = false;
        this.dropdownClick = false;
        this.renderSuggestions = false;

        this.state = {
            suggestions: [],
            inputValue: inputValue,
            inputValueChanged: false,
        }
    }

    componentDidMount() {
        const {items, value, itemValueAttrName, getItemValue} = this.props;
        const inputValue = value ? getItemValue(value, itemValueAttrName || "name") : "";

        this.updateSuggestions(inputValue, items);
    }

    componentWillUnmount() {
        this.componentIsUnmounting = true;
    }

    updateSuggestions = (inputValue, items) => {
        const {minCharsForFilter, filterSuggestions, getItemValue, itemValueAttrName, dropdown} = this.props;

        if (minCharsForFilter === 0 || (inputValue && inputValue.length >= minCharsForFilter) || (this.dropdownClick && dropdown)) {
            filterSuggestions(inputValue, items, getItemValue, itemValueAttrName || "name")
                .then(suggestions => {
                    if (!this.componentIsUnmounting) {
                        this.setState({
                            suggestions: suggestions,
                        })
                    }
                })
                .catch(() => {
                    if (!this.componentIsUnmounting) {
                        this.setState({
                            suggestions: [],
                        })
                    }
                })
        } else {
            this.setState({
                suggestions: []
            });
        }
    };

    componentWillReceiveProps(nextProps) {
        if (document.activeElement !== this.refs.autosuggest.input || nextProps.value) {
            const inputValue = nextProps.value ? nextProps.getItemValue(nextProps.value, nextProps.itemValueAttrName || "name") : "";
            if (this.props.value !== nextProps.value || this.state.inputValue !== inputValue) {
                this.setState({
                    inputValue: nextProps.value ? nextProps.getItemValue(nextProps.value, nextProps.itemValueAttrName || "name") : "",
                    inputValueChanged: false,
                }, () => {
                    this.updateSuggestions(inputValue, nextProps.items);
                })
            }
        }
    }

    handleInputChange = (e, {newValue, method}) => {
        const {onChange, value} = this.props;

        switch (method) {
            case "type":
                if (value) {
                    onChange(null);
                }

                this.setState({
                    inputValue: newValue,
                    inputValueChanged: true,
                }, () => {
                    if (!this.componentIsUnmounting) {
                        if (value) {
                            // console.log("virtual blur!")
                            this.ignoreBlur = true;
                            this.refs.autosuggest.input.blur();
                            this.refs.autosuggest.input.focus();
                            this.ignoreBlur = false;
                        }
                    }
                });
                break;
            case "up":
                break;
            case "down":
                break;
        }
    };

    handleSuggestionSelected = (event, { suggestion, suggestionValue, sectionIndex, method }) => {
        const {tags, onChange} = this.props;
        event.stopPropagation();
        event.preventDefault();
        onChange && onChange(suggestion)

        if (tags) { // vynulujeme hodnotu
            this.setState({
                inputValue: "",
                inputValueChanged: false,
            }, () => {
                // this.ignoreBlur = true;
                // this.refs.autosuggest.input.blur();
                this.hasFocus = false;
                // setTimeout(() => {
                //     this.refs.autosuggest.input.focus();
                //     this.ignoreBlur = false;
                //     this.hasFocus = true;
                // }, 100);
            });
        }
    };

    handleBlur = (e) => {
        if (this.ignoreBlur) {
            return;
        }

        const {onBlur, value} = this.props;
        const {inputValueChanged} = this.state;

        this.hasFocus = false;
        this.dropdownClick = false;
        this.renderSuggestions = false;

        if (inputValueChanged) {    // hodnota inputu byla zmněněná a nebyla znovu vybrána položka z menu, nastavíme vybranou položku na null
            onBlur && onBlur(null);
        } else {
            onBlur && onBlur(value ? value : null);
        }
    };

    handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.stopPropagation();
            event.preventDefault();
        }
    };

    handleRenderSuggestions = (item) => {
        const {value, itemValueAttrName, renderSuggestion, getItemValue} = this.props;
        const {inputValue} = this.state;
        const selected = value ? (value.id === item.id) : false;
        return renderSuggestion(item, selected, getItemValue, itemValueAttrName || "name", value ? null : inputValue);
    };

    handleSuggestionsUpdateRequested = ({value}) => {
        // console.log("handleSuggestionsUpdateRequested", value)
        const {items} = this.props;
        this.updateSuggestions(value, items);
    };

    handleRenderSuggestionsContainer = ({ ref, ...rest }) => {
        const callRef = isolatedScroll => {
            if (isolatedScroll !== null) {
                ref(isolatedScroll.component);
            }
        };

        return <IsolatedScroll {...rest} ref={callRef} />;
    };

    handleClear = (e) => {
        e.stopPropagation();
        e.preventDefault();
        const {onChange} = this.props;
        onChange(null);
        this.setState({
            inputValue: "",
            inputValueChanged: true,
        }, () => {
            if (!this.componentIsUnmounting) {
                this.ignoreBlur = true;
                this.refs.autosuggest.input.blur();
                this.refs.autosuggest.input.focus();
                this.ignoreBlur = false;
            }
        });
    };

    handleDropdown = (e) => {
        //console.log("handleDropdown", this.hasFocus, this.renderSuggestions);
        this.dropdownClick = true;
        if (!this.renderSuggestions || !this.hasFocus) {
            e.stopPropagation();
            e.preventDefault();
            this.ignoreBlur = true;
            this.refs.autosuggest.input.blur();
            this.refs.autosuggest.input.focus();
            this.ignoreBlur = false;
            this.hasFocus = true;
        } else {
            this.renderSuggestions = false;
        }
    };

    handleFocus = (e) => {
        const {onFocus} = this.props;
        this.hasFocus = true;
        onFocus && onFocus(e);
    };

    shouldRenderSuggestions = (value) => {
        const {inputValue, inputValueChanged} = this.state;
        const {shouldRenderSuggestions, minCharsForFilter} = this.props;

        // TODO NOPEPARTS
        let shouldRenderSuggestionsFc
            shouldRenderSuggestionsFc = () => {
                return (!inputValue || (inputValue && inputValueChanged));
            }
        //console.warn(minCharsForFilter === 0, inputValue, value, !!inputValue, inputValue.length >= minCharsForFilter);
        const result = shouldRenderSuggestionsFc(value) && shouldRenderSuggestions(value) && (this.dropdownClick ? true : (minCharsForFilter === 0 || (!!value && value.length >= minCharsForFilter)));
        this.renderSuggestions = result;
        return result;
    };

    render() {
        const {inputValue, suggestions, inputValueChanged} = this.state;
        const {
            renderSuggestion,
            itemValueAttrName,
            shouldRenderSuggestions,
            filterSuggestions,
            className,
            getItemValue,
            addonsBefore,
            addonsAfter,
            value,
            disabled,
            onChange,
            onFocus,
            onBlur,
            items,
            placeholder,
            dropdown,
            removable,
            minCharsForFilter,
            title,
            ...otherProps} = this.props;
        // TODO NOPEPARTS
        // Vynucení zobrazení nabídky, pokud se má zobrazovat
        let alwaysRenderSuggestions;
        alwaysRenderSuggestions = this.alwaysRenderSuggestions ? true : false;
        // if (this.shouldRenderSuggestions()) {
        // } else {
        //     alwaysRenderSuggestions = false;
        // }
        this.alwaysRenderSuggestions = false;
// console.log(222, this.refs.autosuggest)
// console.log(111, "inputValue", inputValue, "inputValueChanged", inputValueChanged, "shouldRenderSuggestions", this.shouldRenderSuggestions(), "alwaysRenderSuggestions", alwaysRenderSuggestions)

        // Pokud není title zvenku definované, zobrazíme v title vybranou hodnotu
        const useTitle = title || inputValue;

        const field = <div className={`autosuggest-container ${className}`}>
            <Autosuggest
                ref="autosuggest"
                alwaysRenderSuggestions={alwaysRenderSuggestions}
                theme={SUGGEST_THEME}
                getSuggestionValue={getItemValue}
                renderSuggestion={this.handleRenderSuggestions}
                shouldRenderSuggestions={this.shouldRenderSuggestions}
                suggestions={(minCharsForFilter === 0 || (inputValue && inputValue.length >= minCharsForFilter) || (this.dropdownClick && dropdown)) ? suggestions : []}
                onSuggestionsClearRequested={() => {this.handleSuggestionsUpdateRequested({value: ""})}}
                onSuggestionsFetchRequested={this.handleSuggestionsUpdateRequested}
                onSuggestionSelected={this.handleSuggestionSelected}
                renderSuggestionsContainer={this.handleRenderSuggestionsContainer}
                {...otherProps}
                inputProps={{
                    title: useTitle,
                    value: inputValue || "",
                    onChange: this.handleInputChange,
                    onBlur: this.handleBlur,
                    onFocus: this.handleFocus,
                    onKeyDown: this.handleKeyDown,
                    disabled: disabled,
                    placeholder: placeholder
                }}
            />
        </div>;

        let hasAddonInline = false;
        const editAddons = [];
        let inlineAddon;
        if (dropdown) {
            if (value) {
                if (!disabled) {
                    hasAddonInline = true;
                    inlineAddon = <div className="input-group-btn input-addon-inline"><Button type="button" tabIndex={-1} ref="dropdownButton" onMouseDown={this.handleClear}><Icon fixedWidth icon='remove' /></Button></div>;
                }
            } else {
                hasAddonInline = true;
                inlineAddon = <div className="input-group-btn input-addon-inline"><Button type="button" tabIndex={-1} ref="dropdownButton" onMouseDown={this.handleDropdown}><Icon fixedWidth icon='caret-down'/></Button></div>;
            }
        } else if (removable) {
            if (value && !disabled) {
                hasAddonInline = true;
                inlineAddon = <div className="input-group-btn input-addon-inline"><Button type="button" tabIndex={-1} ref="dropdownButton" onMouseDown={this.handleClear}><Icon fixedWidth icon='remove'/></Button></div>;
            }
        }
        // editAddons.push(<div className="input-group-btn"><Button type="button" tabIndex={-1} ref="dropdownButton" onMouseDown={this.handleClear}><Icon fixedWidth icon='remove' /></Button></div>);
        // editAddons.push(<div className="input-group-btn"><Button type="button" tabIndex={-1} ref="dropdownButton" onMouseDown={this.handleClear}><Icon fixedWidth icon='plus' /></Button></div>);

        const fieldWrapper = <div className={`autosuggest-dropdown-field ${hasAddonInline ? "has-addon-inline" : ""}`}>
            {field}
            {inlineAddon}
        </div>

        return this.renderFieldWithAddons(fieldWrapper, addonsBefore, mergeAddons(addonsAfter, editAddons));

        // if (dropdown) {
        //     return <div className="autosuggest-dropdown-input-wrapper">
        //         {this.renderFieldWithAddons(field, addonsBefore, addonsAfter)}
        //         <div className="input-group-btn dropdown-caret2">
        //             {!value && <Button type="button" tabIndex={-1} ref="dropdownButton" onMouseDown={this.handleDropdown}><Icon fixedWidth icon='caret-down'/></Button>}
        //             {value &&
        //             <Button type="button" tabIndex={-1} ref="dropdownButton" onMouseDown={this.handleClear}><Icon fixedWidth icon='remove' /></Button>}
        //         </div>
        //     </div>
        // } else if (removable) {
        //     return <div className={value ? "autosuggest-dropdown-input-wrapper" : ""}>
        //         {this.renderFieldWithAddons(field, addonsBefore, addonsAfter)}
        //         {value && <div className="input-group-btn dropdown-caret2">
        //             <Button type="button" tabIndex={-1} ref="dropdownButton" onMouseDown={this.handleClear}><Icon fixedWidth icon='remove' /></Button>
        //         </div>}
        //     </div>
        // } else {
        //     return this.renderFieldWithAddons(field, addonsBefore, addonsAfter);
        // }
    }
}

export default ObjectSuggestField;
